// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Manrope", sans-serif;
  background-color: #ffffff;
  color: #1a1c1d;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

/* Typography */
h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #454652;
  font-size: 1.125rem;
}

/* Material Icons Setup */
.material-symbols-outlined {
  font-variation-settings:
    "FILL" 0,
    "wght" 400,
    "GRAD" 0,
    "opsz" 24;
  vertical-align: middle;
}
.material-symbols-outlined.filled {
  font-variation-settings: "FILL" 1;
}

/* --- Top Navigation --- */
.top-nav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 64px;
  background-color: #f9f9fb;
  border-bottom: 1px solid #e2e2e4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
  z-index: 50;
}

.nav-brand {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.05em;
  color: #0b1a7d;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  color: #454652;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn:hover {
  background-color: #eeeef0;
}

.icon-btn:active {
  opacity: 0.8;
}

.profile-pic {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #dfe0ff;
  margin-left: 8px;
}

/* --- Layout Structure --- */
.layout-wrapper {
  display: flex;
  min-height: 100vh;
  padding-top: 64px; /* Account for fixed header */
}

/* --- Sidebar Navigation --- */
.sidebar {
  position: fixed;
  top: 64px;
  left: 0;
  width: 256px;
  height: calc(100vh - 64px);
  background-color: #f3f3f5;
  border-right: 1px solid #e2e2e4;
  display: flex;
  flex-direction: column;
  padding: 24px 0;
}

.sidebar-menu {
  flex: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  text-decoration: none;
  color: #454652;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  transition: all 0.2s;
}

.menu-item:hover {
  background-color: #ffffff;
}

.menu-item.active {
  background-color: #dfe0ff;
  color: #303c9a;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 16px 8px;
}

.section-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #c6c5d4;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.add-btn, .delete-btn {
  background: none;
  border: none;
  color: #c6c5d4;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.add-btn:hover, .delete-btn:hover {
  color: #0b1a7d;
}

.project-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.delete-btn {
  margin-left: auto;
  opacity: 0;
}

.task-card .delete-btn {
  opacity: 1;
}

.menu-item:hover .delete-btn {
  opacity: 1;
}


#project-input {
  padding: 8px 16px;
  border: 1px solid rgba(11, 26, 125, 0.147);
}

/* --- Main Content Area --- */
.main-content {
  margin-left: 256px;
  flex: 1;
  padding: 48px;
  background-color: #ffffff;
}

.content-container {
  max-width: 1024px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 48px;
}

/* --- Task List --- */
.task-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.task-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #ffffff;
  border: 1px solid #e8e8ea;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.task-card:hover {
  border-color: #c6c5d4;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.task-card.completed {
  opacity: 0.6;
}

.task-card.completed .task-title {
  text-decoration: line-through;
}

.task-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Checkbox Styling */
.checkbox-container {
  width: 24px;
  height: 24px;
  border: 2px solid #c6c5d4;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
}

.task-card:hover .checkbox-container:not(.checked) {
  border-color: #0b1a7d;
}

.checkbox-inner {
  width: 12px;
  height: 12px;
  background-color: #0b1a7d;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}

.task-card:hover .checkbox-inner:not(.checked) {
  opacity: 0.1;
}

.checkbox-container.checked {
  background-color: #0b1a7d;
  border-color: #0b1a7d;
}

.checkbox-container.checked .check-icon {
  color: #ffffff;
  font-size: 14px;
  pointer-events: none;
}

.task-title {
  font-size: 1.125rem;
  font-weight: 500;
  color: #1a1c1d;
}

/* --- Badges --- */
.task-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.badge-time {
  background-color: #e8e8ea;
  color: #454652;
}

.badge-time.no-due-date {
  background-color: #fff9cf;
  color: #cbb61c;
}

.badge-high {
  background-color: #ffdad6;
  color: #ba1a1a;
  font-weight: 700;
}

.badge-medium {
  background-color: #fff4d6;
  color: #ba8d1a;
  font-weight: 700;
}

.badge-low {
  background-color: #d6d9ff;
  color: #1a1dba;
  font-weight: 700;
}

.badge-icon {
  font-size: 10px;
}

/* --- Floating Action Button --- */
.new-task-btn {
  position: fixed;
  right: 32px;
  bottom: 32px;
  width: 56px;
  height: 56px;
  background-color: #0b1a7d;
  color: #ffffff;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 25px rgba(11, 26, 125, 0.3);
  cursor: pointer;
  transition: transform 0.2s;
  z-index: 50;
}

.new-task-btn:hover {
  transform: scale(1.1);
}

.new-task-btn:active {
  transform: scale(0.95);
}

.fab-icon {
  font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE;;;;aAIW;EACX,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,eAAe;EACf,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Base Reset */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Manrope\", sans-serif;\n  background-color: #ffffff;\n  color: #1a1c1d;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Typography */\nh1 {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin-bottom: 0.5rem;\n}\n\n.subtitle {\n  color: #454652;\n  font-size: 1.125rem;\n}\n\n/* Material Icons Setup */\n.material-symbols-outlined {\n  font-variation-settings:\n    \"FILL\" 0,\n    \"wght\" 400,\n    \"GRAD\" 0,\n    \"opsz\" 24;\n  vertical-align: middle;\n}\n.material-symbols-outlined.filled {\n  font-variation-settings: \"FILL\" 1;\n}\n\n/* --- Top Navigation --- */\n.top-nav {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  height: 64px;\n  background-color: #f9f9fb;\n  border-bottom: 1px solid #e2e2e4;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 32px;\n  z-index: 50;\n}\n\n.nav-brand {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  color: #0b1a7d;\n}\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.icon-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  color: #454652;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-btn:hover {\n  background-color: #eeeef0;\n}\n\n.icon-btn:active {\n  opacity: 0.8;\n}\n\n.profile-pic {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #dfe0ff;\n  margin-left: 8px;\n}\n\n/* --- Layout Structure --- */\n.layout-wrapper {\n  display: flex;\n  min-height: 100vh;\n  padding-top: 64px; /* Account for fixed header */\n}\n\n/* --- Sidebar Navigation --- */\n.sidebar {\n  position: fixed;\n  top: 64px;\n  left: 0;\n  width: 256px;\n  height: calc(100vh - 64px);\n  background-color: #f3f3f5;\n  border-right: 1px solid #e2e2e4;\n  display: flex;\n  flex-direction: column;\n  padding: 24px 0;\n}\n\n.sidebar-menu {\n  flex: 1;\n  padding: 0 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.menu-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  text-decoration: none;\n  color: #454652;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  transition: all 0.2s;\n}\n\n.menu-item:hover {\n  background-color: #ffffff;\n}\n\n.menu-item.active {\n  background-color: #dfe0ff;\n  color: #303c9a;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 32px 16px 8px;\n}\n\n.section-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #c6c5d4;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n.add-btn, .delete-btn {\n  background: none;\n  border: none;\n  color: #c6c5d4;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.add-btn:hover, .delete-btn:hover {\n  color: #0b1a7d;\n}\n\n.project-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.delete-btn {\n  margin-left: auto;\n  opacity: 0;\n}\n\n.task-card .delete-btn {\n  opacity: 1;\n}\n\n.menu-item:hover .delete-btn {\n  opacity: 1;\n}\n\n\n#project-input {\n  padding: 8px 16px;\n  border: 1px solid rgba(11, 26, 125, 0.147);\n}\n\n/* --- Main Content Area --- */\n.main-content {\n  margin-left: 256px;\n  flex: 1;\n  padding: 48px;\n  background-color: #ffffff;\n}\n\n.content-container {\n  max-width: 1024px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 48px;\n}\n\n/* --- Task List --- */\n.task-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.task-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background-color: #ffffff;\n  border: 1px solid #e8e8ea;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.task-card:hover {\n  border-color: #c6c5d4;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.task-card.completed {\n  opacity: 0.6;\n}\n\n.task-card.completed .task-title {\n  text-decoration: line-through;\n}\n\n.task-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Checkbox Styling */\n.checkbox-container {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #c6c5d4;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.2s;\n}\n\n.task-card:hover .checkbox-container:not(.checked) {\n  border-color: #0b1a7d;\n}\n\n.checkbox-inner {\n  width: 12px;\n  height: 12px;\n  background-color: #0b1a7d;\n  border-radius: 50%;\n  opacity: 0;\n  transition: opacity 0.2s;\n  pointer-events: none;\n}\n\n.task-card:hover .checkbox-inner:not(.checked) {\n  opacity: 0.1;\n}\n\n.checkbox-container.checked {\n  background-color: #0b1a7d;\n  border-color: #0b1a7d;\n}\n\n.checkbox-container.checked .check-icon {\n  color: #ffffff;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n.task-title {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: #1a1c1d;\n}\n\n/* --- Badges --- */\n.task-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.badge-time {\n  background-color: #e8e8ea;\n  color: #454652;\n}\n\n.badge-time.no-due-date {\n  background-color: #fff9cf;\n  color: #cbb61c;\n}\n\n.badge-high {\n  background-color: #ffdad6;\n  color: #ba1a1a;\n  font-weight: 700;\n}\n\n.badge-medium {\n  background-color: #fff4d6;\n  color: #ba8d1a;\n  font-weight: 700;\n}\n\n.badge-low {\n  background-color: #d6d9ff;\n  color: #1a1dba;\n  font-weight: 700;\n}\n\n.badge-icon {\n  font-size: 10px;\n}\n\n/* --- Floating Action Button --- */\n.new-task-btn {\n  position: fixed;\n  right: 32px;\n  bottom: 32px;\n  width: 56px;\n  height: 56px;\n  background-color: #0b1a7d;\n  color: #ffffff;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 10px 25px rgba(11, 26, 125, 0.3);\n  cursor: pointer;\n  transition: transform 0.2s;\n  z-index: 50;\n}\n\n.new-task-btn:hover {\n  transform: scale(1.1);\n}\n\n.new-task-btn:active {\n  transform: scale(0.95);\n}\n\n.fab-icon {\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
